<template>
  <div>
    <div class="hdp-head">
      <StepBack @route="onRoute" :route="{name: 'HomeView'}" />
      <div class="hdp-h1">{{ $t('ticketHeading') }}</div>
    </div>
    <div class="hdp-h2">{{ $t('ticketSubHeading') }}</div>
    <div class="hdp-alert hdp-alert-success" v-if="success">{{ $t('ticketSuccess') }} <strong>{{ seconds }}</strong></div>
    <div class="hdp-alert hdp-alert-danger" v-if="errors.length">
      <div v-for="error in errors" :key="error.field">{{ error.message }}</div>
    </div>
    <form @submit.prevent="sendForm" :class="{ 'hdp-processing': isProcessing }">
      <div class="hdp-form-line">
        <input class="hdp-field" v-model="fields.name" type="text" :placeholder="$t('ticketName')" required>
      </div>
      <div class="hdp-form-line">
        <input class="hdp-field" v-model="fields.custom_fields.login_into_terminal" type="text" :placeholder="$t('ticketLogin')" required>
      </div>
      <div class="hdp-form-line">
        <input class="hdp-field" v-model="fields.email" type="email" pattern="\S+@\S+\.\S+" :placeholder="$t('ticketEmail')" required>
      </div>
      <div class="hdp-form-line">
        <v-select
          v-model="selected"
          :options="options"
          :searchable="false"
          :clearable="false"
          :onChange="onChange"
        >
        </v-select>
        <div v-if="selectedText" class="hdp-selected-text">{{selectedText}}</div>
      </div>
      <div class="hdp-form-line">
        <input class="hdp-field" v-model="fields.subject" type="text" :placeholder="$t('ticketSubject')" required>
      </div>
      <div class="hdp-form-line">
        <textarea class="hdp-field hdp-field-textarea" v-model="fields.description" cols="30" rows="10" :placeholder="$t('ticketDescription')" required></textarea>
      </div>
      <div class="hdp-form-line" v-if="cordova">
        <div class="hdp-btn hdp-field-file-label" @click="takePhoto">{{ $t('ticketAttachCaption') }}</div>
      </div>
      <div class="hdp-form-line" v-else>
        <input class="hdp-field-file" type="file" id="hdp-file" @change="attachFiles" multiple>
        <label for="hdp-file" class="hdp-btn hdp-field-file-label" :data-caption="$t('ticketAttachCaption')" :data-multiple-caption="$t('ticketAttachMultipleCaption')">{{ $t('ticketAttachCaption') }}</label>
      </div>
      <div class="hdp-form-line">
        <input type="submit" class="hdp-btn hdp-field-submit" :value="$t('ticketSubmit')">
      </div>
    </form>
  </div>
</template>

<script>
/* global _ */
import utils from '@/utils'
import api from '@/api'
import StepBack from '@/components/StepBack'

export default {
  name: 'TicketView',

  components: {
    StepBack
  },

  data () {
    return {
      cordova: window.cordova,
      formData: new FormData(),
      fields: {
        name: '',
        email: '',
        type: this.$t('ticketOptionGeneral.value', 'en'),
        subject: '',
        description: '',
        priority: 1,
        status: 2,
        source: 8,
        custom_fields: {
          login_into_terminal: ''
        }
      },
      errors: [],
      success: false,
      isProcessing: false,
      seconds: 3,
      counter: null,
      options: [
        { label: this.$t('ticketOptionGeneral.value'), value: this.$t('ticketOptionGeneral.value', 'en'), text: this.$t('ticketOptionGeneral.text') },
        { label: this.$t('ticketOptionRecovery.value'), value: this.$t('ticketOptionRecovery.value', 'en'), text: this.$t('ticketOptionRecovery.text') },
        { label: this.$t('ticketOptionRefill.value'), value: this.$t('ticketOptionRefill.value', 'en'), text: this.$t('ticketOptionRefill.text') },
        { label: this.$t('ticketOptionWithdrawals.value'), value: this.$t('ticketOptionWithdrawals.value', 'en'), text: this.$t('ticketOptionWithdrawals.text') },
        { label: this.$t('ticketOptionFinancial.value'), value: this.$t('ticketOptionFinancial.value', 'en'), text: this.$t('ticketOptionFinancial.text') },
        { label: this.$t('ticketOptionClosing.value'), value: this.$t('ticketOptionClosing.value', 'en'), text: this.$t('ticketOptionClosing.text') }
      ],
      selected: { label: this.$t('ticketOptionGeneral.value'), value: this.$t('ticketOptionGeneral.value', 'en'), text: this.$t('ticketOptionGeneral.text') },
      selectedText: ''
    }
  },

  watch: {
    selected (option) {
      this.fields.type = option.value
    }
  },

  created () {
    utils.tealiumTrack(this, {
      page_type: 'new ticket'
    })

    if (this.cordova) {
      this.closeKeyboard()
    }
  },

  beforeDestroy () {
    clearInterval(this.counter)
  },

  methods: {
    createContact () {
      const formDataCreateContact = new FormData()

      formDataCreateContact.append('name', this.fields.name)
      formDataCreateContact.append('email', this.fields.email)
      formDataCreateContact.append('language', utils.mapLangs(this.$lang))

      return api.createContact({
        method: 'POST',
        body: formDataCreateContact
      })
    },
    async sendForm () {
      const options = {
        method: 'POST',
        body: this.formData
      }

      this.addFields()
      this.isProcessing = true
      this.errors = []

      await this.createContact()
      const res = await api.createTicket(options)

      this.$root.$el.parentNode.scrollTop = 0

      if (res.errors) {
        this.isProcessing = false
        this.errors = res.errors
      } else {
        this.success = true
        this.counter = setInterval(() => {
          this.seconds--
          if (this.seconds === 0) {
            this.$emit('route', {name: 'HomeView'})
          }
        }, 1000)
      }
    },
    takePhoto () {
      if (window.Camera && navigator.camera) {
        navigator.camera.getPicture(this.takePhotoSuccess.bind(this), this.takePhotoFail.bind(this), {
          quality: 80,
          destinationType: window.Camera.DestinationType.FILE_URI,
          sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY // Camera for take photo from camera and camera.PictureSourceType.PHOTOLIBRARY to pick from file system
        })
      }
    },
    takePhotoSuccess (fileURI) {
      this.appendPhoto(fileURI)
    },
    takePhotoFail (error) {
      console.error(error)
    },
    appendPhoto (fileURI) {
      const self = this
      window.resolveLocalFileSystemURL(fileURI, function (fileEntry) {
        fileEntry.file(function (file) {
          const reader = new FileReader()
          reader.onloadend = function (e) {
            const label = document.querySelector('.hdp-field-file-label')
            const fileBlob = new Blob([this.result], { type: file.type === null ? 'image/png' : file.type })
            const fileName = file.localURL.substr(file.localURL.lastIndexOf('/') + 1)

            self.formData.delete('attachments[]')
            self.formData.append('attachments[]', fileBlob, fileName)
            label.innerHTML = fileName
          }
          reader.readAsArrayBuffer(file)
        }, function (e) {
          console.error('Getting file error: ', e)
        })
      }, function (error) {
        console.log(error)
      })
    },
    // attach files for web
    attachFiles (e) {
      const input = e.target
      const label = input.nextElementSibling
      const files = input.files || e.dataTransfer.files
      const filesLength = files.length
      let fileName

      this.formData.delete('attachments[]')

      for (let i = 0; i < filesLength; i++) {
        this.formData.append('attachments[]', files[i])
      }

      if (filesLength > 1) {
        fileName = `${label.getAttribute('data-multiple-caption')} ${filesLength}`
      } else {
        fileName = input.value.split('\\').pop()
      }

      label.innerHTML = fileName || label.getAttribute('data-caption')
    },
    addFields () {
      for (let field in this.$data.fields) {
        if (typeof this.$data.fields[field] === 'object') {
          for (let val in this.$data.fields[field]) {
            this.formData.append(`${field}[${val}]`, this.$data.fields[field][val])
          }
        } else {
          this.formData.append(field, this.$data.fields[field])
        }
      }

      this.formData.append('tags[]', utils.mapBroker[this.$categoryId])
      this.formData.append('tags[]', utils.mapLangs(this.$lang))
    },
    onChange (option) {
      this.fields.type = option.value
      this.selectedText = option.text
    },
    onRoute (route) {
      this.$emit('route', route)
    },
    closeKeyboard () {
      this.$root.$el.addEventListener('click', (e) => {
        const types = ['text', 'textarea', 'email']
        if (!types.includes(e.target.type) && _.keyboardIsVisible()) {
          this.cordova.plugins.Keyboard.close()
        }
      })
    }
  }
}
</script>

<style scoped>
  .hdp-processing {
    position: relative;
  }
  .hdp-processing:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(36, 37, 38, .8)
  }
  .hdp-form-line {
    margin-bottom: 10px;
  }
  .hdp-field {
    box-sizing: border-box;
    display: block;
    width: 100%;
    height: calc(2.25rem + 2px);
    padding: .375rem .75rem;
    font-size: 16px;
    line-height: 1.5;
    border: none;
    border-radius: .25rem;
    background-color: #fff;
    background-clip: padding-box;
    color: #000000;
  }
  .hdp-field-textarea {
    height: 150px;
    resize: vertical;
    font-family: inherit;
    /* fix focus in ios */
    -webkit-user-select: text;
    /* https://stackoverflow.com/questions/44795085/input-field-bug-on-ios-text-turns-white */
    transform: translateZ(0);
  }
  .hdp-field-submit {
    width: 100%;
    height: calc(2.25rem + 2px);
    outline: none;
  }
  .hdp-field-file {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  .hdp-field-file-label {
    vertical-align: top;
    background-image: url(../assets/svg/icon-attach.svg);
    background-repeat: no-repeat;
    background-position: left 10px center;
    padding-left: 40px;
    max-width: 100%;
  }
  .hdp-selected-text {
    font-size: 13px;
    padding: 5px;
  }
  .hdp-alert {
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
  }
  .hdp-alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  .hdp-alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
</style>

<style>
  #app .v-select .dropdown-toggle {
    background: #fff;
    border: 0;
    padding: .375rem .75rem;
  }
  #app .v-select .vs__selected-options {
    flex-wrap: nowrap;
    padding: 0;
  }
  #app .v-select .selected-tag {
    margin: 0;
    padding: 0;
    border: 0;
  }
  #app .v-select.single.open .selected-tag {
    position: relative;
  }
  #app .v-select .vs__actions {
    padding: 0;
  }
  #app .v-select .dropdown-menu {
    border: 0;
  }
  #app .v-select .open-indicator:before {
    width: 8px;
    height: 8px;
    border-width: 2px 2px 0 0;
  }
  #app .v-select li > a {
    padding: 3px .75rem;
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// src/views/TicketView.vue